import { z } from "zod";
import { isoDateOnlySchema } from "../common/date.js";
export const createBlockedDateSchema = z
    .object({
    start_date: isoDateOnlySchema,
    end_date: isoDateOnlySchema,
    summary: z.string().min(1).max(200).optional(),
})
    .refine((data) => data.end_date > data.start_date, {
    message: "La date de fin doit etre posterieure a la date de debut.",
    path: ["end_date"],
});
